import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function PrivacyPage() {
 return (
  <StaticPageLayout title='Privacy Policy' lastUpdated='2024-03-15'>
   <p>
    At MOCK.SYSTEM, accessible from mock.ai, one of our main priorities is the
    privacy of our visitors. This Privacy Policy document contains types of
    information that is collected and recorded by MOCK.SYSTEM and how we use it.
   </p>

   <h3>Information We Collect</h3>
   <p>
    We collect information to provide better services to all our users. This
    includes:
   </p>
   <ul>
    <li>
     Personal identification information (Name, email address, phone number,
     etc.)
    </li>
    <li>Resume and professional data uploaded to the platform</li>
    <li>Interview performance metrics and recordings</li>
   </ul>

   <h3>How We Use Your Information</h3>
   <p>We use the information we collect in various ways, including to:</p>
   <ul>
    <li>Provide, operate, and maintain our webiste</li>
    <li>Improve, personalize, and expand our website</li>
    <li>Understand and analyze how you use our website</li>
    <li>Develop new products, services, features, and functionality</li>
   </ul>
  </StaticPageLayout>
 );
}
